"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_query_1 = require("@tanstack/react-query");
const svgs_1 = require("@@/assets/svgs");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Menu_1 = __importDefault(require("@mui/material/Menu"));
const Grow_1 = __importDefault(require("@mui/material/Grow"));
const Fade_1 = __importDefault(require("@mui/material/Fade"));
const _1 = require(".");
const queryClient = new react_query_1.QueryClient();
function default_1() {
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const showNotification = Boolean(anchorEl);
    const openNotification = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const closeNotification = () => {
        setAnchorEl(null);
    };
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    return ((0, jsx_runtime_1.jsxs)(react_query_1.QueryClientProvider, Object.assign({ client: queryClient }, { children: [(0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ sx: {
                    p: maxWidth768 ? 0 : '4px',
                    borderRadius: '8px',
                    bgcolor: `${showNotification ? 'var(--table-row)' : 'var(--white)'} !important`,
                }, onClick: openNotification }, { children: (0, jsx_runtime_1.jsx)(svgs_1.BellIconSvg, { css: { width: '24px', height: '24px' } }) })), (0, jsx_runtime_1.jsxs)(Menu_1.default, Object.assign({ id: "notification_log", anchorEl: anchorEl, autoFocus: false, open: showNotification, onClose: closeNotification, marginThreshold: 0, PaperProps: {
                    sx: {
                        width: maxWidth768 ? '100%' : '414px',
                        height: maxWidth768 ? '100%' : '650px',
                        maxWidth: 'none',
                        maxHeight: 'none',
                        borderRadius: maxWidth768 ? 0 : '16px',
                    },
                }, MenuListProps: { sx: { width: '100%', height: '100%', overflow: 'hidden' } }, anchorOrigin: maxWidth768 ? undefined : { vertical: 'bottom', horizontal: 84 }, transformOrigin: { vertical: 'top', horizontal: 'right' }, TransitionComponent: maxWidth768 ? Fade_1.default : Grow_1.default }, { children: [maxWidth768 && (0, jsx_runtime_1.jsx)(_1.NotificationMobileSubHeader, { closeNotification: closeNotification }), (0, jsx_runtime_1.jsx)(_1.NotificationLogFilter, { showNotification: showNotification }), (0, jsx_runtime_1.jsx)(_1.NotificationLog, {})] }))] })));
}
exports.default = default_1;
